import { render } from "./ToolBar.vue?vue&type=template&id=0f4b8d34"
import script from "./ToolBar.vue?vue&type=script&lang=js"
export * from "./ToolBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__